var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowdownFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M7.525 9.995q0-.158.103-.27a.35.35 0 0 1 .272-.113h8.2q.168 0 .272.116a.4.4 0 0 1 .103.27q0 .039-.125.264l-3.95 3.95a.7.7 0 0 1-.177.125.5.5 0 0 1-.223.05.5.5 0 0 1-.223-.05.7.7 0 0 1-.177-.125l-3.95-3.95a.5.5 0 0 1-.087-.119.3.3 0 0 1-.038-.148"
})));
export default SvgArrowdownFill;